import Reveal from "@/components/base/Reveal";
import { site } from "@/mocks/site";

const kv = [
  { label: "Adres", value: "Halaskargazi Cad. Maya Apt. No:94 K:1 D:1 · Osmanbey / Şişli" },
  { label: "Metro", value: "M2 Osmanbey durağı — 2 dk yürüme" },
  { label: "Çalışma", value: "Pzt–Cum 09:00–19:00 · Cmt 09:00–17:00" },
  { label: "İletişim", value: "0 553 730 71 30 · 0 212 343 30 30" },
];

const accessList = [
  "M2 metro hattı — Osmanbey durağı",
  "Şişli–Mecidiyeköy–Maslak aksı üzeri",
  "Yakın çevrede otopark imkânı",
  "Engelli erişimi (giriş kat)",
  "WhatsApp'tan yol tarifi isteyin",
];

export default function AboutLocation() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.24em] text-primary-600">
                <span className="h-px w-7 bg-primary-400" aria-hidden="true" />
                Konum
              </span>
              <h2 className="mt-5 font-heading text-3xl font-medium leading-tight tracking-tight text-foreground-950 md:text-4xl">
                İstanbul'un kalbinde, kolay ulaşım
              </h2>
              <p className="mt-6 text-base leading-relaxed text-foreground-600">
                Halaskargazi Caddesi üzerinde, M2 metro hattı Osmanbey durağına 2 dakikalık yürüme
                mesafesindeyiz. Yakın çevrede otopark imkânı mevcuttur.
              </p>

              <dl className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {kv.map((row) => (
                  <div key={row.label} className="relative overflow-hidden rounded-xl border border-background-200 bg-background-50 px-5 py-4">
                    <span
                      className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                      aria-hidden="true"
                    />
                    <dt className="text-[11px] font-bold uppercase tracking-[0.16em] text-foreground-500">
                      {row.label}
                    </dt>
                    <dd className="mt-1.5 text-sm font-medium text-foreground-800">{row.value}</dd>
                  </div>
                ))}
              </dl>

              <ul className="mt-8 flex flex-col gap-2.5">
                {accessList.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-map-pin-2-line mt-0.5 text-base text-primary-600" aria-hidden="true" />
                    <span className="text-sm text-foreground-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
              <iframe
                title="d.mar Dental Görüntüleme Merkezi konum haritası"
                src={site.mapEmbed}
                className="h-72 w-full lg:h-96"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="flex flex-col items-start justify-between gap-4 p-6 sm:flex-row sm:items-center">
                <p className="text-sm text-foreground-600">{site.address}</p>
                <a
                  href={site.directions}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-road-map-line text-base" aria-hidden="true" />
                  Yol Tarifi Al
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}